const SHIPPING_BANNER_FILENAME = 'upload_pic_1784189139849_1920_PromoBanner.png';

export function resolveJapanImageAlt(src, alt = '') {
  const imagePath = String(src || '').split(/[?#]/)[0];

  // 这张横幅已更新为 ¥6,000，但后台低代码配置仍保留旧的替代文本。
  if (imagePath.endsWith(`/${SHIPPING_BANNER_FILENAME}`) && alt === '¥4,000以上 送料無料') {
    return '¥6,000以上 送料無料';
  }

  return alt;
}
